// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"67d6dc6d","542":"2a9f4aaa","646":"1a5b923e"}[chunkId] + ".chunk.js";
};